interface RecommendationSummaryProps {
    recommendation?: any;
}

export function RecommendationSummary({ recommendation }: RecommendationSummaryProps) {
    const rec = (recommendation as any)?.recommendation || recommendation;
    if (!rec) return null;

    return (
        <div className="mb-4 p-3 bg-white rounded-lg border border-gray-200">
            <div className="font-semibold text-base mb-2">Recommendation Summary</div>
            <div className="text-sm">
                <p><span className="font-medium">ID:</span> {rec.id || 'N/A'}</p>
                <p><span className="font-medium">Action:</span> {rec.description || 'N/A'}</p>
            </div>
        </div>
    );
}
